export default "__VITE_ASSET__OduGctTY__"